const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

export default function emailValid(value: string): boolean {
    return EMAIL.test(value.trim());
}
